// Util functions

import moment from 'moment/moment'
import axios from 'axios'
import { filter } from 'bluebird'
// Todo: Simplify this
let u = {}

u.clone = function(json) {
  return JSON.parse(JSON.stringify(json))
}

u.processResp = function(obj) {
  // obj.id = obj.hexId

  if (obj.createdAt) {
    obj.createdAtLocal = moment(obj.createdAt)
      .utc()
      .local()
      .format('DD MMM YYYY hh:mm:ss a')
  }
  if (obj.changedAt) {
    obj.changedAtLocal = moment(obj.changedAt)
      .utc()
      .local()
      .format('DD MMM YYYY hh:mm:ss a')
  }
  for (let prop in obj) {
    if (u.isObject(obj[prop])) {
      u.processResp(obj[prop])
    } else if (u.isArray(obj[prop])) {
      obj[prop] = obj[prop].map(p => {
        return typeof p === 'object' ? u.processResp(p) : p
      })
    }
  }
  return obj
}

u.adaptTemplate = function(t) {
  let template = {
    name: t.templateName,
    description: t.templateDescription,
    type: t.hiveType,
    system: t.hiveName,
    ...t
  }
  return template
}

u.isObject = function(a) {
  return !!a && a.constructor === Object
}

u.isArray = function(a) {
  return !!a && a.constructor === Array
}

u.checkUrlHasFilters = function(route) {
  const { query } = route
  if (query.filter) {
    const filters = atob(query.filter.toString())
    const params = new URLSearchParams(filters)
    return params
  }
}

u.getFiltersFromUrl = function() {
  const params = u.checkUrlHasFilters(this.$route)
  let obj
  if (params) {
    obj = {}
    this.page = +params.get('page')
    obj.page = +params.get('page')
  }
  if (params && params.has('search')) {
    obj.search = params.get('search')
  }
  if (params && params.has('sort')) {
    const sortStr = params.get('sort').split(',')
    obj.sortBy = sortStr[0]
    obj.sortOrder = sortStr[1]
  }
  this.pagination = obj
  return obj
}

u.createFilters = function(obj) {
  let search = null
  let sortBy
  let sortOrder
  if (obj) {
    if (obj.page) {
      this.page = obj.page
    }
    if (obj.search) {
      search = obj.search
    }
    if (obj.sortBy) {
      sortBy = obj.sortBy
      sortOrder = obj.sortOrder
    }
  }
  let filter = `?page=${this.page}&size=10`
  if (search) {
    filter = filter + `&search=${search}`
  }
  if (sortBy) {
    filter = filter + `&sort=${sortBy},${sortOrder}`
  }
  return filter
}

export default u
